import { CONFIG } from '@h2h/shared';

// Onboarding walks a brand-new player through the game *as it actually plays today*,
// using the same building blocks as the live app (flag emblems, sport marks, LIVE/SOON
// pills, the dark featured card) so it reads as one product. It covers the breadth —
// football leagues, cycling races, more sports coming — and the loop: call → stake →
// climb. Every game number is read from CONFIG so the copy can never drift.
export const FB_BASE = CONFIG.COMBO.BASE_POINTS;
export const FB_MAX_LEGS = CONFIG.COMBO.MAX_LEGS;
export const CY_TOP = CONFIG.CYCLING.CONFIDENCE_WEIGHTS[0];
export const DUELS = CONFIG.CYCLING.DUELS_PER_STAGE;
export const GOALS_LINE = CONFIG.TOTAL_GOALS_LINE;
